
<div *ngIf="waitingForApi" style="text-align: center">
    <div id="loading"></div>
</div>